<nz-modal
  [nzWidth]="'60vw'"
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #modalTitle>
    <div style="font-weight: 600 !important">Change Password</div>
  </ng-template>
  <form nz-form [formGroup]="validateForm" [nzLayout]="'vertical'" class="login-form" (ngSubmit)="submitForm()">
    <ng-container *nzModalContent>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Current Password</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="errorPwd">
              <nz-input-wrapper>
                <input
                  [type]="!showCurrPwd ? 'password' : 'text'"
                  nz-input
                  autoComplete="new-password"
                  formControlName="currentPassword"
                  placeholder="Enter Current Password"
                  (ngModelChange)="updateConfirmValidator2()"
                />
                <img
                  nzInputSuffix
                  height="18"
                  width="18"
                  style="cursor: pointer"
                  [src]="showCurrPwd ? 'assets/images/eye.svg' : 'assets/images/eye-slash.svg'"
                  (click)="onShowCurrPwd(showCurrPwd)"
                />
              </nz-input-wrapper>
              <ng-template #errorPwd let-control>
                @if (control.errors?.['required']) {
                  Current Password is required!
                }
                @if (control.errors?.['passwordStrength']) {
                  Password must contain at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special
                  character.
                }
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>New Password</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="errorPwd">
              <nz-input-wrapper>
                <input
                  [type]="!showPwd ? 'password' : 'text'"
                  nz-input
                  formControlName="newPassword"
                  autoComplete="new-password"
                  placeholder="Enter New Password"
                  (ngModelChange)="updateConfirmValidator1()"
                />
                <img
                  nzInputSuffix
                  height="18"
                  width="18"
                  style="cursor: pointer"
                  [src]="showPwd ? 'assets/images/eye.svg' : 'assets/images/eye-slash.svg'"
                  (click)="onShowPwd1(showPwd)"
                />
              </nz-input-wrapper>
              <ng-template #errorPwd let-control>
                @if (control.errors?.['required']) {
                  New Password is required!
                }
                @if (control.errors?.['passwordStrength']) {
                  Password must contain at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special
                  character.
                }
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Confirm Password</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="errorTpl">
              <nz-input-wrapper>
                <input
                  nz-input
                  [type]="!showConfPwd ? 'password' : 'text'"
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                  formControlName="confirmPassword"
                  id="confirmPassword"
                />
                <img
                  nzInputSuffix
                  height="18"
                  width="18"
                  style="cursor: pointer"
                  [src]="showConfPwd ? 'assets/images/eye.svg' : 'assets/images/eye-slash.svg'"
                  (click)="onShowConfPwd(showConfPwd)"
                />
              </nz-input-wrapper>
              <ng-template #errorTpl let-control>
                @if (control.errors?.['required']) {
                  Please confirm your password!
                }
                @if (control.errors?.['confirm']) {
                  Passwords must match!
                }
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </ng-container>

    <ng-template #modalFooter>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
          <button nz-button nzType="primary" (click)="submitForm()">Save</button>
        </nz-form-control>
      </nz-form-item>
    </ng-template>
  </form>
</nz-modal>
